export default {
  mainPage: 'होम पेज',
  additionalInformationAdded: 'अतिरिक्त जानकारी जोड़ी गई',
  assignOrSelectTheNameFromTheList: 'सूची से नाम असाइन या चयन करें',
  AddPeopleToAnExistingList: 'लोगों को मौजूदा सूची में जोड़ें',
  updateList: 'अद्यतन सूची',
  eventModified: 'संशोधित घटना',
  completeTheRequiredFields: 'आवश्यक फ़ील्ड को पूरा करें',
  anErrorHasOcurred: 'एक त्रुटि हुई',
  insertKeybeUiOnYourWebsite: 'अपनी वेबसाइट में Keybe UI सम्मिलित करना',
  toInsertKeybeUiIntoYourWebsiteYouMustCreateADivElementWithTheIdKeybe: ' अपनी वेबसाइट पर KeybeUI को एम्बेड करने के लिए. आपको अपनी साइट बॉडी में \'कीब\' आईडी के साथ एक DIV तत्व बनाना होगा',
  andThenAddTheFollowingScriptInTheFooterOfYourSite: 'और फिर अपनी साइट के फुटर में निम्नलिखित स्क्रिप्ट जोड़ें',
  toAddElementsInTheDOMToOpenTheKeybeUIYouCanUseAScriptSimilarToTheFollowing: 'डोम में आइटम जोड़ने के लिए जो आपको KeybeUI खोलने की अनुमति देता है. आप निम्नलिखित के समान स्क्रिप्ट का उपयोग कर सकते हैं',
  selectProfilePhoto: 'प्रोफाइल पिक्चर चुनें',
  selectPhoto: 'फोटो चुनें',
  photoSuccessfullyUpdated: 'फोटो सही ढंग से अपडेट किया गया',
  select: 'चुनें'
}
